import React from 'react'
import PropTypes from 'prop-types'
import * as Styled from './Cart.styled'
import { Text } from 'components/text'
import { Box } from 'components/box'

const Cart = props => {
  const { label, isActive, ...rest } = props

  return (
    <Styled.Cart {...rest}>
      <Box display="flex" flexDirection="column" justifyContent="center">
        <Text
          color={isActive ? 'primary.black' : 'secondary.greymedium'}
          textStyle="subnav"
          display={{ _: 'none', sm: 'block' }}
          mr="1"
        >
          Cart
        </Text>
      </Box>
      <Box
        color={isActive ? 'primary.black' : 'secondary.greymedium'}
        height="100%"
        display="flex"
        flexDirection="column"
        justifyContent="center"
      >
        <Styled.CartIcon name="cart" size="md" label={label} />
      </Box>
    </Styled.Cart>
  )
}

Cart.propTypes = {
  label: PropTypes.number,
  isActive: PropTypes.bool,
}

Cart.defaultProps = {
  label: 0,
}

export default Cart
